import { customFetchBase } from "../../utils/API/fetchBaseQuery";
import { transformRequest } from "../../utils/API/requestMiddleware";
import { transformErrorResponse, transformSuccessResponse } from "../../utils/API/responseMiddleware";
import { createApi } from "@reduxjs/toolkit/query/react";

// Create User API
const timesheetReportAPI = createApi({
    reducerPath: "timesheetReportAPI",
    baseQuery: customFetchBase,
    endpoints: (builder) => ({

        getTimesheetReportListByUserFilter: builder.mutation({
            query: (data) => ({
                url: `/TimeSheet/GetTimesheetReportListByUserFilter`,
                method: 'POST',
                body: transformRequest(data)
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        getAllEmployeeAuditReport: builder.mutation({
            query: (data) => ({
                url: `/TimeSheet/GetAllEmployeeAuditReport`,
                method: 'POST',
                body: transformRequest(data)
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        getTimesheetReportListByProjectFilter: builder.mutation({
            query: (data) => ({
                url: `/TimeSheet/GetTimesheetReportListByProjectFilter`,
                method: 'POST',
                body: transformRequest(data)
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),


        getTimesheetReportListByProjectWiseFilter: builder.mutation({
            query: (data) => ({
                url: `/TimeSheet/GetTimesheetReportListByProjectWiseFilter`,
                method: 'POST',
                body: transformRequest(data)

            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        exportTimesheetReportListByUserFilter: builder.mutation({
            query: (data) => ({
                url: `/TimeSheet/ExportTimesheetReportListByUserFilter`,
                method: 'POST',
                body: transformRequest(data),
                responseHandler: (response) => response.blob(),
            }),
            // transformResponse: transformSuccessResponse,
            // transformErrorResponse: transformErrorResponse,
        }),
        exportTimesheetReportListByProjectFilter: builder.mutation({
            query: (data) => ({
                url: `/TimeSheet/ExportTimesheetReportListByProjectFilter`,
                method: 'POST',
                body: transformRequest(data),
                responseHandler: (response) => response.blob(),
            }),
            // transformResponse: transformSuccessResponse,
            // transformErrorResponse: transformErrorResponse,
        }),
        exportTimesheetReportListByProjectWiseFilter: builder.mutation({
            query: (data) => ({
                url: `/TimeSheet/ExportTimesheetReportListByProjectWiseFilter`,
                method: 'POST',
                body: transformRequest(data),
                responseHandler: (response) => response.blob(),
            }),
            // transformResponse: transformSuccessResponse,
            // transformErrorResponse: transformErrorResponse,
        }),

        exportExportGetAllEmployeeAuditReport: builder.mutation({
            query: (data) => ({
                url: `/TimeSheet/ExportGetAllEmployeeAuditReport`,
                method: 'POST',
                body: transformRequest(data),
                responseHandler: (response) => response.blob(),
            }),
            // transformResponse: transformSuccessResponse,
            // transformErrorResponse: transformErrorResponse,
        }),
    })
});

// Extract hooks for easy access to various API requests 
export const {
    useGetTimesheetReportListByUserFilterMutation,
    useGetAllEmployeeAuditReportMutation,
    useGetTimesheetReportListByProjectFilterMutation,
    useGetTimesheetReportListByProjectWiseFilterMutation,
    useExportTimesheetReportListByUserFilterMutation,
    useExportTimesheetReportListByProjectFilterMutation,
    useExportTimesheetReportListByProjectWiseFilterMutation,
    useExportExportGetAllEmployeeAuditReportMutation,

} = timesheetReportAPI;

export default timesheetReportAPI;